/**
 * RowSearch
 * One row with text input and search modal
 * Returns the code and name
 */
import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { Row, Field } from 'react-gridforms'
import { Field as Field2, actions } from 'react-redux-form/immutable'
import InputGroup, { Button as IButton } from 'react-bootstrap/lib/InputGroup'
import Search from 'react-icons/lib/md/search'
import trim from 'validator/lib/trim'

import errBlock from 'components/ErrBlock'
import Input from 'components/Input'
import SearchModal from 'components/SearchModal'

class RowSearch extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openSearch: false,
    }
  }

  _showSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _hideSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  // on select search results
  _onSelectItem = (item, focus) => {
    const { dispatch, model, model1, model2 } = this.props
    // dispatch model changes
    dispatch(actions.change(model, item.get('id')))
    dispatch(actions.change(model1, item.get('code')))
    dispatch(actions.change(model2, item.get('name')))
    this.setState({
      openSearch: false,
    })
    if (focus !== true) {
      this.props.onFinish()
    }
  }

  _fireSearch = (e) => {
    const { dispatch, model, model1, model2, onSearch } = this.props
    const value = trim(e.target.value)
    if (!value) {
      // reset values
      dispatch(actions.change(model, null))
      dispatch(actions.change(model1, null))
      dispatch(actions.change(model2, null))
    } else {
      dispatch(onSearch(value))
        .then((res) => {
          let item = fromJS({
            id: '',
            code: value,
            name: '',
          })

          const results = fromJS(res.payload || [])
          if (results.size > 0) {
            item = results.get(0)
          }

          this._onSelectItem(item, true)
        })
    }
  }

  _onSubmit = (term) => {
    const { dispatch, onSearch } = this.props
    dispatch(onSearch(term))
  }

  _renderSearch() {
    const { openSearch } = this.state
    const { placeholder, results } = this.props

    if (!openSearch) {
      return null
    }

    return (
      <SearchModal
        placeholder={placeholder}
        handleClose={this._hideSearch}
        onSubmit={this._onSubmit}
        results={results}
        onSelectItem={this._onSelectItem}
      />
    )
  }

  render() {
    const { label1, label2, model, model1, model2, required, disabled, autoFocus } = this.props

    return (
      <Row>
        <Field span="1" data-disabled={disabled ? 'true' : ''}>
          <Field2 model={model1}>
            <label htmlFor={label1}>{label1} {required && <span className="req">*</span>}</label>
            <InputGroup>
              <IButton>
                <button
                  type="button"
                  onClick={this._showSearch}
                  tabIndex="-1"
                  className="btn-icon"
                  disabled={disabled}
                ><Search /></button>
              </IButton>
              <input
                type="text"
                className="form-control"
                onBlur={this._fireSearch}
                disabled={disabled}
                autoFocus={autoFocus}
              />
              {errBlock(model)}
            </InputGroup>
          </Field2>
        </Field>
        <Field span="3" data-disabled="true">
          <Input
            model={model2}
            label={label2}
            disabled
          />
          {this._renderSearch()}
        </Field>
      </Row>
    )
  }
}

RowSearch.propTypes = {
  placeholder: PropTypes.string,
  dispatch: PropTypes.func,
  results: PropTypes.object,
  onSearch: PropTypes.func,
  onFinish: PropTypes.func,
}

export default connect()(RowSearch)



// WEBPACK FOOTER //
// ./src/components/RowSearch/index.js